import script from "./FlyerDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyerDetail.vue?vue&type=script&setup=true&lang=js"

import "./FlyerDetail.vue?vue&type=style&index=0&id=84fcab06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84fcab06"]])

export default __exports__